import { ExportStatus, Export, TaskType, ExportTypes } from '@dev/ee-api/ee-api-models';
import { AxiosPromise } from 'axios';

import { request } from './request';

export type GetExportsParams = {
    type?: TaskType;
    name?: string;
    statuses?: ExportStatus[];
    types?: ExportTypes[];
    limit?: number;
    offset?: number;
    search?: string;
};

export const checkTaskStatus = (id: string): AxiosPromise<ExportStatus> => {
    const { Tasks } = request();

    return Tasks.tasksByIdStatusGet(id);
};

export const loadTasks = (params: GetExportsParams): AxiosPromise<Export[]> => {
    const { Tasks } = request();
    const { type, search, statuses, types, limit, offset } = params;

    return Tasks.tasksGet(type, search, statuses, types, limit, offset);
};

// export const findExports = (_params: GetExportsParams): any => {
//     const { Tasks } = request();
//     const { name, statuses, types, limit, offset } = params;
//     return Tasks.tasksByNameGet(name, '', statuses, types, limit, offset);
// };

export const deleteTask = (id: string): AxiosPromise<void> => {
    const { Tasks } = request();

    return Tasks.tasksByIdDelete(id);
};
